import React from 'react'
import UploadStore from '../../stores/upload-store'
import UploadErrorMessage from './upload-error-message'
import createReactClass from 'create-react-class'

var UploadErrors = createReactClass({

    componentDidMount: function () {

        //Listen for changes in the UploadStore
        UploadStore.addChangeListener(this._onChange);
    },
    componentWillUnmount: function () {
        //Stop listening for changes in the UploadStore
        UploadStore.removeChangeListener(this._onChange);
    },
    getInitialState: function () {
        //The state for this component is managed in the UploadStore
        return UploadStore.getData();
    },

    //This is called when the store has some updated data for us
    _onChange: function () {
        this.setState(UploadStore.getData());
    },
    removeErrorMessage: function (index) {

    },

    //Render the HTML for the component
    render: function () {
        if (this.state.uploadErrors.length == 0) {
            return <div></div>;
        } else {
            var messageList = [];
            for (var i = 0; i < this.state.uploadErrors.length; i++) {
                messageList.push(<UploadErrorMessage key={i} message={this.state.uploadErrors[i]} messageId={i}/>);
            }
            return <div className="ope_upload__error">{messageList}</div>
        }
    }
});

export default UploadErrors;
